import { render, staticRenderFns } from "./orderArrow.vue?vue&type=template&id=01087710&scoped=true&"
import script from "./orderArrow.vue?vue&type=script&lang=js&"
export * from "./orderArrow.vue?vue&type=script&lang=js&"
import style0 from "./orderArrow.vue?vue&type=style&index=0&id=01087710&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01087710",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01087710')) {
      api.createRecord('01087710', component.options)
    } else {
      api.reload('01087710', component.options)
    }
    module.hot.accept("./orderArrow.vue?vue&type=template&id=01087710&scoped=true&", function () {
      api.rerender('01087710', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/center/market/orderArrow.vue"
export default component.exports